import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { SubMenu } from 'react-pro-sidebar';
import { verify_path } from '../utils/getPermissions';

interface Props {
  children: JSX.Element[] | JSX.Element;
  pathList: string[];
  pathName: string;
  label: string;
  collapsed: boolean;
  icon?: ReactElement | null;
  showingMainMenu?: boolean;
  onToggle?: () => void;
}

const SubMenuComponent = ({
  children,
  pathList,
  pathName,
  label,
  collapsed,
  showingMainMenu,
  icon = null,
  onToggle,
}: Props) => {
  // El estado ahora es controlado completamente por el prop 'collapsed' del padre
  const isOpen = !collapsed;

  const handleSubMenuToggle = () => {
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <SubMenu
      open={isOpen}
      onClick={handleSubMenuToggle}
      label={label}
      icon={icon}
    >
      {children}
    </SubMenu>
  );
};

export default SubMenuComponent;
